export const partnerThemes = {
  // default: {
  //   bgColor: "#ffffff",
  //   name: "default",
  //   backgroundColor: "bg-[#ffffff]",
  //   headingColor: "text-[#915DA5]",
  //   subHeadingColor: "text-[#555555]",
  //   primaryButtonBgColor: "#915DA5",
  //   primaryButtonTextColor: "#ffffff",
  //   textColor: "#666666",
  //   logo: "/assets/icons/b2b/housr-logo.svg",
  // },
  housr: {
    name: "housr",
    bgColor: "#ffffff",
    backgroundColor: "bg-[#ffffff]",
    peerFocusColor: "peer-focus:bg-[#ffffff]",
    headingColor: "text-[#915DA5]",
    borderColor: "border-[#915DA5]",
    subHeadingColor: "text-[#555555]",
    primaryButtonBgColor: "bg-[#915DA5]",
    primaryButtonBgColorCode: "#915DA5",
    primaryButtonTextColor: "text-[#ffffff]",
    textColor: "text-[#666666]",
    darkTextColor: "text-[#555555]",
    greyBorderColor: "border-[#99999]",
    darkBorderColor: "border-[#555555]",
    logo: "src/assets/icons/b2b/housr-logo.svg",
    tint: "bg-[#FFF4FF]",
    glowColor: "text-[#FF06F7]",
  },
  xu: {
    name: "xu",
    bgColor: "#ffffff",
    backgroundColor: "bg-[#ffffff]",
    peerFocusColor: "peer-focus:bg-[#ffffff]",
    headingColor: "text-[#222]",
    borderColor: "border-[#CEC5FF]",
    subHeadingColor: "text-[#555555]",
    primaryButtonBgColor: "bg-[#5C45DE]",
    primaryButtonBgColorCode: "#5C45DE",
    primaryButtonTextColor: "text-[#ffffff]",
    textColor: "text-[#666666]",
    darkTextColor: "text-[#555555]",
    greyBorderColor: "border-[#99999]",
    darkBorderColor: "border-[#555555]",
    logo: "src/assets/icons/b2b/xu-logo.svg",
    tint: "bg-[#F4F2FF]",
    glowColor: "text-[#826CFF]",
  },
  hw: {
    name: "hw",
    bgColor: "#ffffff",
    backgroundColor: "bg-[#ffffff]",
    peerFocusColor: "peer-focus:bg-[#ffffff]",
    headingColor: "text-[#222]",
    borderColor: "border-[#CEC5FF]",
    subHeadingColor: "text-[#555555]",
    primaryButtonBgColor: "bg-[#2CA471]",
    primaryButtonBgColorCode: "#2CA471",
    primaryButtonTextColor: "text-[#ffffff]",
    textColor: "text-[#666666]",
    darkTextColor: "text-[#555555]",
    greyBorderColor: "border-[#99999]",
    darkBorderColor: "border-[#555555]",
    logo: "src/assets/icons/b2b/hello-world.svg",
    tint: "bg-[#F4F2FF]",
    glowColor: "text-[#826CFF]",
  },
  nestaway: {
    name: "nestaway",
    bgColor: "#ffffff",
    backgroundColor: "bg-[#ffffff]",
    peerFocusColor: "peer-focus:bg-[#ffffff]",
    headingColor: "text-[#222]",
    borderColor: "border-[#CEC5FF]",
    subHeadingColor: "text-[#555555]",
    primaryButtonBgColor: "bg-[#5564ae]",
    primaryButtonBgColorCode: "#5564ae",
    primaryButtonTextColor: "text-[#ffffff]",
    textColor: "text-[#666666]",
    darkTextColor: "text-[#555555]",
    greyBorderColor: "border-[#99999]",
    darkBorderColor: "border-[#555555]",
    logo: "src/assets/icons/b2b/hello-world.svg",
    tint: "bg-[#F4F2FF]",
    glowColor: "text-[#826CFF]",
  },
  meridianstays: {
    name: "meridianstays",
    bgColor: "#ffffff",
    backgroundColor: "bg-[#ffffff]",
    peerFocusColor: "peer-focus:bg-[#ffffff]",
    headingColor: "text-[#222]",
    borderColor: "border-[#CEC5FF]",
    subHeadingColor: "text-[#555555]",
    primaryButtonBgColor: "bg-[#FC0405]",
    primaryButtonBgColorCode: "#FC0405",
    primaryButtonTextColor: "text-[#ffffff]",
    textColor: "text-[#666666]",
    darkTextColor: "text-[#555555]",
    greyBorderColor: "border-[#99999]",
    darkBorderColor: "border-[#555555]",
    logo: "src/assets/icons/b2b/hello-world.svg",
    tint: "bg-[#F4F2FF]",
    glowColor: "text-[#826CFF]",
  },
  stanza: {
    name: "stanza",
    bgColor: "#ffffff",
    backgroundColor: "bg-[#ffffff]",
    peerFocusColor: "peer-focus:bg-[#ffffff]",
    headingColor: "text-[#60c3ad]",
    borderColor: "border-[#60c3ad]",
    subHeadingColor: "text-[#555555]",
    primaryButtonBgColor: "bg-[#60c3ad]",
    primaryButtonBgColorCode: "#60c3ad",
    primaryButtonTextColor: "text-[#ffffff]",
    textColor: "text-[#666666]",
    darkTextColor: "text-[#555555]",
    greyBorderColor: "border-[#999999]",
    darkBorderColor: "border-[#555555]",
    logo: "src/assets/icons/b2b/stanza-logo.svg",
    tint: "bg-[#60c3ad]/10",
    glowColor: "text-[#60c3ad]",
  },
  fabhostels: {
    name: "fabhostels",
    bgColor: "#ffffff",
    backgroundColor: "bg-[#ffffff]",
    peerFocusColor: "peer-focus:bg-[#ffffff]",
    headingColor: "text-[#FFC300]",
    borderColor: "border-[#FFC300]",
    subHeadingColor: "text-[#555555]",
    primaryButtonBgColor: "bg-[#FFC300]",
    primaryButtonBgColorCode: "#FFC300",
    primaryButtonTextColor: "text-[#ffffff]",
    textColor: "text-[#666666]",
    darkTextColor: "text-[#555555]",
    greyBorderColor: "border-[#999999]",
    darkBorderColor: "border-[#555555]",
    logo: "src/assets/icons/b2b/stanza-logo.svg",
    tint: "bg-[#FFC300]/10",
    glowColor: "text-[#FFC300]",
  },
  kots: {
    name: "kots",
    bgColor: "#ffffff",
    backgroundColor: "bg-[#ffffff]",
    peerFocusColor: "peer-focus:bg-[#ffffff]",
    headingColor: "text-[#afa11e]",
    borderColor: "border-[#afa11e]",
    subHeadingColor: "text-[#a2a2a2]",
    primaryButtonBgColor: "bg-[#afa11e]",
    primaryButtonBgColorCode: "#afa11e",
    primaryButtonTextColor: "text-[#ffffff]",
    textColor: "text-[#666666]",
    darkTextColor: "text-[#555555]",
    greyBorderColor: "border-[#99999]",
    darkBorderColor: "border-[#555555]",
    logo: "src/assets/icons/b2b/kots.svg",
    tint: "bg-[#F4F2FF]",
    glowColor: "text-[#ffffff]",
  },
  oxotel: {
    name: "oxotel",
    bgColor: "#ffffff",
    backgroundColor: "bg-[#ffffff]",
    peerFocusColor: "peer-focus:bg-[#ffffff]",
    headingColor: "text-[#BA988B]",
    borderColor: "border-[#BA988B]",
    subHeadingColor: "text-[#BA988B]",
    primaryButtonBgColor: "bg-[#BA988B]",
    primaryButtonBgColorCode: "#BA988B",
    primaryButtonTextColor: "text-[#ffffff]",
    textColor: "text-[#666666]",
    darkTextColor: "text-[#555555]",
    greyBorderColor: "border-[#99999]",
    darkBorderColor: "border-[#555555]",
    logo: "src/assets/icons/b2b/oxotel.webp",
    tint: "bg-[#BA988B2d]",
    glowColor: "text-[#ffffff]",
  },
  tribe: {
    name: "tribe",
    bgColor: "#ffffff",
    backgroundColor: "bg-[#ffffff]",
    peerFocusColor: "peer-focus:bg-[#ffffff]",
    headingColor: "text-[#E3431E]",
    borderColor: "border-[#E3431E]",
    subHeadingColor: "text-[#E3431E]",
    primaryButtonBgColor: "bg-[#E3431E]",
    primaryButtonBgColorCode: "#E3431E",
    primaryButtonTextColor: "text-[#ffffff]",
    textColor: "text-[#666666]",
    darkTextColor: "text-[#555555]",
    greyBorderColor: "border-[#99999]",
    darkBorderColor: "border-[#555555]",
    logo: "src/assets/icons/b2b/tribe.svg",
    tint: "bg-[#E3431E2d]",
    glowColor: "text-[#ffffff]",
  },
  circlepe: {
    name: "circlepe",
    bgColor: "#ffffff",
    backgroundColor: "bg-[#ffffff]",
    peerFocusColor: "peer-focus:bg-[#ffffff]",
    headingColor: "text-[#5E7BFF]",
    borderColor: "border-[#5E7BFF]",
    subHeadingColor: "text-[#5E7BFF]",
    primaryButtonBgColor: "bg-[#5E7BFF]",
    primaryButtonBgColorCode: "#5E7BFF",
    primaryButtonTextColor: "text-[#ffffff]",
    textColor: "text-[#666666]",
    darkTextColor: "text-[#555555]",
    greyBorderColor: "border-[#999999]",
    darkBorderColor: "border-[#555555]",
    logo: "src/assets/icons/b2b/circlepe.jpg",
    tint: "bg-[#5E7BFF2d]",
    glowColor: "text-[#ffffff]",
  },
  truliv: {
    name: "truliv",
    bgColor: "#ffffff",
    backgroundColor: "bg-[#ffffff]",
    peerFocusColor: "peer-focus:bg-[#ffffff]",
    headingColor: "text-[#F45C2C]",
    borderColor: "border-[#F45C2C]",
    subHeadingColor: "text-[#F45C2C]",
    primaryButtonBgColor: "bg-[#F45C2C]",
    primaryButtonBgColorCode: "#F45C2C",
    primaryButtonTextColor: "text-[#ffffff]",
    textColor: "text-[#666666]",
    darkTextColor: "text-[#555555]",
    greyBorderColor: "border-[#999999]",
    darkBorderColor: "border-[#555555]",
    logo: "src/assets/icons/b2b/truliv_logo.jpeg",
    tint: "bg-[#F45C2C2d]",
    glowColor: "text-[#ffffff]",
  },
  friendzo: {
    name: "friendzo",
    bgColor: "#ffffff",
    backgroundColor: "bg-[#ffffff]",
    peerFocusColor: "peer-focus:bg-[#ffffff]",
    headingColor: "text-[#0053bf]",
    borderColor: "border-[#0053bf]",
    subHeadingColor: "text-[#0053bf]",
    primaryButtonBgColor: "bg-[#0053bf]",
    primaryButtonBgColorCode: "#0053bf",
    primaryButtonTextColor: "text-[#ffffff]",
    textColor: "text-[#666666]",
    darkTextColor: "text-[#555555]",
    greyBorderColor: "border-[#999999]",
    darkBorderColor: "border-[#555555]",
    logo: "src/assets/icons/b2b/friendzo.png",
    tint: "bg-[#0053bf]/10",
    glowColor: "text-[#ffffff]",
  },
  capacity_capital: {
    name: "capacity_capital",
    bgColor: "#ffffff",
    backgroundColor: "bg-[#ffffff]",
    peerFocusColor: "peer-focus:bg-[#ffffff]",
    headingColor: "text-[#0a0a0a]",
    borderColor: "border-[#0a0a0a]",
    subHeadingColor: "text-[#0a0a0a]",
    primaryButtonBgColor: "bg-[#0a0a0a]",
    primaryButtonBgColorCode: "#0a0a0a",
    primaryButtonTextColor: "text-[#ffffff]",
    textColor: "text-[#0a0a0a]",
    darkTextColor: "text-[#0a0a0a]",
    greyBorderColor: "border-[#999999]",
    darkBorderColor: "border-[#0a0a0a]",
    logo: "src/assets/icons/b2b/capacity_capital.jpeg",
    tint: "bg-[#0a0a0a]/10",
    glowColor: "text-[#ffffff]",
  },
  youthville: {
    name: "youthville",
    bgColor: "#ffffff",
    backgroundColor: "bg-[#ffffff]",
    peerFocusColor: "peer-focus:bg-[#ffffff]",
    headingColor: "text-[#8cc63e]",
    borderColor: "border-[#8cc63e]",
    subHeadingColor: "text-[#8cc63e]",
    primaryButtonBgColor: "bg-[#8cc63e]",
    primaryButtonBgColorCode: "#8cc63e",
    primaryButtonTextColor: "text-[#ffffff]",
    textColor: "text-[#666666]",
    darkTextColor: "text-[#555555]",
    greyBorderColor: "border-[#999999]",
    darkBorderColor: "border-[#555555]",
    logo: "src/assets/icons/b2b/youthville.jpg",
    tint: "bg-[#8cc63e]/10",
    glowColor: "text-[#ffffff]",
  },
  urbanroomz: {
    name: "urbanroomz",
    bgColor: "#ffffff",
    backgroundColor: "bg-[#ffffff]",
    peerFocusColor: "peer-focus:bg-[#ffffff]",
    headingColor: "text-[#0a0a0a]",
    borderColor: "border-[#0a0a0a]",
    subHeadingColor: "text-[#0a0a0a]",
    primaryButtonBgColor: "bg-[#0a0a0a]",
    primaryButtonBgColorCode: "#0a0a0a",
    primaryButtonTextColor: "text-[#ffffff]",
    textColor: "text-[#0a0a0a]",
    darkTextColor: "text-[#0a0a0a]",
    greyBorderColor: "border-[#999999]",
    darkBorderColor: "border-[#0a0a0a]",
    logo: "src/assets/icons/b2b/urbanroomz-logo.png",
    tint: "bg-[#0a0a0a]/10",
    glowColor: "text-[#ffffff]",
  },
  flent: {
    name: "flent",
    bgColor: "#ffffff",
    backgroundColor: "bg-[#ffffff]",
    peerFocusColor: "peer-focus:bg-[#ffffff]",
    headingColor: "text-[#0a0a0a]",
    borderColor: "border-[#0a0a0a]",
    subHeadingColor: "text-[#0a0a0a]",
    primaryButtonBgColor: "bg-[#0a0a0a]",
    primaryButtonBgColorCode: "#0a0a0a",
    primaryButtonTextColor: "text-[#ffffff]",
    textColor: "text-[#0a0a0a]",
    darkTextColor: "text-[#0a0a0a]",
    greyBorderColor: "border-[#999999]",
    darkBorderColor: "border-[#0a0a0a]",
    logo: "src/assets/icons/b2b/flent-logo.svg",
    tint: "bg-[#0a0a0a]/10",
    glowColor: "text-[#333333]",
  },
  blossomstayz: {
    name: "blossomstayz",
    bgColor: "#ffffff",
    backgroundColor: "bg-[#ffffff]",
    peerFocusColor: "peer-focus:bg-[#ffffff]",
    headingColor: "text-[#2c266a]",
    borderColor: "border-[#2c266a]",
    subHeadingColor: "text-[#555555]",
    primaryButtonBgColor: "bg-[#b02e89]",
    primaryButtonBgColorCode: "#b02e89",
    primaryButtonTextColor: "text-[#ffffff]",
    textColor: "text-[#2c266a]",
    darkTextColor: "text-[#2c266a]",
    greyBorderColor: "border-[#999999]",
    darkBorderColor: "border-[#2c266a]",
    logo: "src/assets/icons/b2b/blossom_stayz_transparent.png",
    tint: "bg-[#2c266a]/10",
    glowColor: "text-[#b02e89]",
  },
};
